import { render } from "./add-payment-method.vue?vue&type=template&id=edce177e&scoped=true"
import script from "./add-payment-method.vue?vue&type=script&lang=js"
export * from "./add-payment-method.vue?vue&type=script&lang=js"

import "./add-payment-method.vue?vue&type=style&index=0&id=edce177e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edce177e"]])

export default __exports__